import React from 'react';
import { useSelector } from 'react-redux';

// selectors
import { getCuratedCollectionsWithCardDetails } from 'js/store/cards/Cards.selectors';
import { getTranslationById } from 'js/store/app/App.selectors';

// components
import HeaderInfo from 'js/components/header/Header.info';
import ActivityCardCarousel from 'js/components/activity-card/ActivityCard.carousel';
import { getSkillTagTranslation } from '../../../store/app/App.selectors';

const CollectionIndex = () => {
  const curatedCollections = useSelector((state) => getCuratedCollectionsWithCardDetails(state)).sort((a, b) => {
    const isCuratedA = a.isCuratedCollection;
    const isCuratedB = b.isCuratedCollection;

    if (isCuratedA && !isCuratedB) return 1;
    if (!isCuratedA && isCuratedB) return -1;
    return 0;
  });
  const title = useSelector((state) => getTranslationById(state, 'collections_page_title', 'Collections'));
  const infoText = useSelector((state) =>
    getTranslationById(
      state,
      'collections_page_info_text_1',
      'This area contains handy collections of activities curated by Sesame Workshop’s educational experts.'
    )
  );

  return (
    <>
      <HeaderInfo title={title} infoText={infoText} />

      {curatedCollections.map((collection) => (
        <ActivityCardCarousel
          key={collection.id}
          title={useSelector((state) => getSkillTagTranslation(state, collection.name))}
          cards={collection.cards.slice(0, 5)}
          url={`/collections/${collection.id}`}
          type={'curated'}
          id={collection.id}
        />
      ))}
    </>
  );
};

export default CollectionIndex;
